import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;
const { Option } = Select;

class UrbioticaSensorSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label='Typ zprávy'>
          {getFieldDecorator('messageType', {
            veluePropName: 'selected',
            initialValue: this.props.initialValues && this.props.initialValues.messageType
              ? this.props.initialValues.messageType
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!'
            }],
          })(
            <Select
              size="default"
              placeholder='Zvolte typ zprávy'
              >
              <Option value="vehicle_ctrl">vehicle_ctrl</Option>
              <Option value="vehicle">vehicle</Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Upozornění" >
          {getFieldDecorator('reportsEnabled', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.reportsEnabled
              ? this.props.initialValues.reportsEnabled
              : false,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Uložit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Nastavení senzoru"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Uložit"
          onOk={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedUrbioticaSensorSettingsForm = Form.create()(UrbioticaSensorSettingsForm);

export default WrappedUrbioticaSensorSettingsForm;


// WEBPACK FOOTER //
// ./src/components/UrbioticaSensorSettingsForm.js